<template lang="pug">
  v-layout.column(v-rc-loader="loading")
    v-layout.pb-3
      v-flex.xs6.pr-2
        rc-current-plan
      v-flex.xs6.pl-2
        rc-estimated-plan
    v-flex.xs12.pb-3
      rc-consumption
    v-flex.xs12
      rc-plan-list
</template>

<script>
import RcCurrentPlan from '@/components/consumption/RcCurrentPlan.vue';
import RcEstimatedPlan from '@/components/consumption/RcEstimatedPlan.vue';
import RcConsumption from '@/components/consumption/RcConsumption.vue';
import RcPlanList from '@/components/consumption/RcPlanList.vue';

export default {
  components: {
    RcCurrentPlan,
    RcEstimatedPlan,
    RcConsumption,
    RcPlanList,
  },
  data() {
    return {
      loading: true,
    };
  },
  mounted() {
    this.$store.dispatch('consumption/get').then(() => {
      this.loading = false;
    });
  },
};
</script>
